import * as React from 'react';
import './TrialInstitutionLayout.scss';
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { TrialSubMenu, TrialInstitutionSubMenu } from '../../../helpers/subMenuHelper';
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import { ComponentType } from 'react';

interface ITrialInstitutionLayoutParams {}

interface ITrialInstitutionLayoutProps extends IRouterProps<ITrialInstitutionLayoutParams> {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    trial?: Dtos.Trial;
    loadingTrial?: boolean;

    trialInstitution?: Dtos.TrialInstitution;
    loadingTrialInstitution?: boolean;

    loading?: boolean;
    children?: any;
}

interface ITrialInstitutionLayoutActions extends IRouterActions {}

type TrialInstitutionLayoutProps = ITrialInstitutionLayoutProps & ITrialInstitutionLayoutActions;

class TrialInstitutionLayout extends React.PureComponent<TrialInstitutionLayoutProps, any> {

    constructor(props: TrialInstitutionLayoutProps) {
        super(props);

    }

    render() {

        const {
            loadingTrial,
            trial,
            permissions,
            loadingTrialInstitution,
            trialInstitution,
            loading
        } = this.props;

        return (
            <RestrictedLayout
                subMenuTitle={trial ? trial.shortDisplay : ""}
                trialId={trial ? trial.id : null}
                institutionId={trialInstitution? trialInstitution.institutionId : null }
                subMenuItems={loadingTrial == undefined || !trial ? [] : TrialSubMenu(trial.id, permissions)}
                sub2MenuTitle={trialInstitution ? trialInstitution.institutionDisplay : ""}
                sub2MenuItems={trialInstitution ? TrialInstitutionSubMenu(trialInstitution, permissions) : []}
                loading={loadingTrial || loadingTrialInstitution || loading}
            >
                {this.props.children}
            </RestrictedLayout>
        );
    }

}


const mapStateToProps = (state: ITmdState, ownProps: TrialInstitutionLayoutProps): ITrialInstitutionLayoutProps => {

    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let trialInstitution: Dtos.TrialInstitution | undefined = !(state.trialInstitution.formData instanceof Array) ? state.trialInstitution.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        history: ownProps.history,
        location: ownProps.location,

        permissions: permissions,
        permission: ownProps.permission,

        trial: trial!,
        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,

        trialInstitution: trialInstitution!,
        loadingTrialInstitution: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Pending,

        loading: ownProps.loading,
        children: ownProps.children,

    };
};

const mapDispatchToProps = (dispatch, ownProps: TrialInstitutionLayoutProps): ITrialInstitutionLayoutActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace
    };
};

export default
    RouterHoc<ITrialInstitutionLayoutParams, TrialInstitutionLayoutProps>((connect(mapStateToProps, mapDispatchToProps)(TrialInstitutionLayout) as unknown as ComponentType<TrialInstitutionLayoutProps>)) as ComponentType<any>;
